module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "选择收货地址1",
      "visible": _vm.addAddressVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addAddressVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.AddressList,
      "border": "",
      "highlight-current-row": true
    },
    on: {
      "cell-click": _vm.currentRow
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Address",
      "label": "收货地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Consignee",
      "label": "收货人",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ConsigneeTel",
      "label": "联系方式"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IsDefault",
      "label": "是否默认"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.IsDefault) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "success"
          }
        }, [_vm._v("当前默认")]) : _c('el-button', {
          attrs: {
            "size": "small",
            "type": "info"
          },
          on: {
            "click": function($event) {
              _vm.setIsDefault(scope.$index, scope.row)
            }
          }
        }, [_vm._v("设为默认")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("新增收货地址")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('areaSelect', {
    ref: "area",
    attrs: {
      "value": _vm.Address,
      "required": "",
      "label-width": "100px"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.ConsigneeAdress),
      callback: function($$v) {
        _vm.$set(_vm.form, "ConsigneeAdress", $$v)
      },
      expression: "form.ConsigneeAdress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.Consignee),
      callback: function($$v) {
        _vm.$set(_vm.form, "Consignee", $$v)
      },
      expression: "form.Consignee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.ConsigneeTel),
      callback: function($$v) {
        _vm.$set(_vm.form, "ConsigneeTel", $$v)
      },
      expression: "form.ConsigneeTel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "设为默认地址"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.form.IsDefault),
      callback: function($$v) {
        _vm.$set(_vm.form, "IsDefault", $$v)
      },
      expression: "form.IsDefault"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("确认添加")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-28ccb166!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/zqwOrder/components/AddressDialog/index.vue
// module id = 1428
// module chunks = 1